const APP_ID = 'dp6ohw8kq3xi2maubclgrny5490esz7f'
const APP_KEY = 'hs7db15igkz6wpnatqev82ymlur9xfc4'
// const APP_ID = 'test'
// const APP_KEY = 'test'

let protocol = document.location.protocol
let hostname
if (protocol === 'https:') {
  hostname = 'https://open.c2h4.org'
} else {
  hostname = 'http://open.c2h4.org'
}

let config = {APP_ID, APP_KEY, protocol, hostname}

export default config



// WEBPACK FOOTER //
// ./src/lib/config.js